// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"7693":"css/app.6708","9254":"css/admin-app.6708"}[chunkId] + ".css";
};